<template>
    <b-modal 
        :id="modalId"
        :title="`Logs de Suscripción: ${subscription.name}`"
        size="xl"
        @show="loadLogs"
        @hidden="resetModal"
        hide-footer
    >
        <div class="subscription-logs">
            <div v-if="loading" class="text-center py-4">
                <b-spinner label="Cargando logs..." variant="primary" />
            </div>
            <div>
                <b-form @submit="(evt) => { evt.preventDefault(); this.$root.$emit('bv::refresh::table', 'event-subcriptions-logs-list') } ">
                    <div class="row pb-3">
                        <b-form-group class="col-3" label="Reservación ID">
                            <b-form-input v-model="filters.reservationId" type="text" />
                        </b-form-group>
                        <b-form-group class="col-2" label=".">
                            <b-button type="submit" variant="primary">Buscar</b-button>
                        </b-form-group>
                    </div>
                </b-form>

                <AjaxTable
                    id="event-subcriptions-logs-list"
                    :columns="fields"
                    :filters="filters"
                    :resource="'event-subscriptions/'+ subscription.id +'/logs'"
                >
                    <template #cell(status)="data">
                        {{ getStatusText(data.value) }}
                    </template>

                    <template #cell(method)="data">
                        <b-badge variant="info">
                            {{ data.value.toUpperCase() }}
                        </b-badge>
                    </template>

                    <template #cell(platform)="data">
                        <b-badge variant="secondary">
                            {{ data.value }}
                        </b-badge>
                    </template>

                    <template #cell(creationDatetime)="data">
                        <small>{{ formatDate(data.value) }}</small>
                    </template>

                    <template #cell(payload)="data">
                        <b-button 
                            v-if="data.value"
                            variant="outline-info" 
                            size="sm"
                            @click="showJsonModal(data.value, 'Payload')"
                        >
                            <md-icon icon="code" />
                        </b-button>
                        <span v-else class="text-muted">-</span>
                    </template>

                    <template #cell(output)="data">
                        <b-button 
                            v-if="data.value"
                            variant="outline-success" 
                            size="sm"
                            @click="showJsonModal(data.value, 'Output')"
                        >
                            <md-icon icon="visibility" />
                        </b-button>
                        <span v-else class="text-muted">-</span>
                    </template>

                    <template #cell(notes)="data">
                        <span v-if="data.value" :title="data.value">
                            {{ data.value.length > 30 ? data.value.substring(0, 30) + '...' : data.value }}
                        </span>
                        <span v-else class="text-muted">-</span>
                    </template>
                </AjaxTable>

            </div>
        </div>

        <!-- JSON Viewer Modal -->
        <b-modal
            id="json-viewer-modal"
            :title="jsonModalTitle"
            size="lg"
            hide-footer
        >
            <pre class="json-viewer"><code>{{ formatJson(jsonModalContent) }}</code></pre>
        </b-modal>
    </b-modal>
</template>

<script>
import AjaxTable from '../../helpers/AjaxTable.vue';

export default {
    components: { AjaxTable },
    name: 'EventSubscriptionLogs',
    props: {
        subscription: {
            type: Object,
            required: true
        },
        modalId: {
            type: String,
            default: 'event-subscription-logs-modal'
        }
    },
    data() {
        return {
            logs: [],
            loading: false,
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            jsonModalTitle: '',
            jsonModalContent: null,
            fields: [
                { 
                    key: 'name', 
                    label: 'Nombre', 
                    sortable: true 
                },
                { 
                    key: 'url', 
                    label: 'URL', 
                    sortable: false,
                    formatter: (value) => {
                        return value && value.length > 40 ? value.substring(0, 40) + '...' : value;
                    }
                },
                { 
                    key: 'method', 
                    label: 'Método', 
                    sortable: true,
                    thClass: 'text-center',
                    tdClass: 'text-center'
                },
                { 
                    key: 'status', 
                    label: 'Estado', 
                    sortable: true,
                    thClass: 'text-center',
                    tdClass: 'text-center'
                },
                { 
                    key: 'platform', 
                    label: 'Plataforma', 
                    sortable: true,
                    thClass: 'text-center',
                    tdClass: 'text-center'
                },
                { 
                    key: 'flowId', 
                    label: 'Flow ID', 
                    sortable: true,
                    thClass: 'text-center',
                    tdClass: 'text-center'
                },
                { 
                    key: 'payload', 
                    label: 'Payload', 
                    sortable: false,
                    thClass: 'text-center',
                    tdClass: 'text-center'
                },
                { 
                    key: 'output', 
                    label: 'Output', 
                    sortable: false,
                    thClass: 'text-center',
                    tdClass: 'text-center'
                },
                { 
                    key: 'notes', 
                    label: 'Notas', 
                    sortable: false 
                },
                { 
                    key: 'creationDatetime', 
                    label: 'Fecha', 
                    sortable: true,
                    thClass: 'text-center',
                    tdClass: 'text-center'
                }
            ],
            filters : {
                reservationId:''
            },
        }
    },
    watch: {
        currentPage() {
            this.loadLogs();
        }
    },
    methods: {
        loadLogs() {
        },

        resetModal() {
            this.logs = [];
            this.currentPage = 1;
            this.totalRows = 0;
            this.jsonModalContent = null;
            this.jsonModalTitle = '';
        },

        getStatusVariant(status) {
            const statusMap = {
                'success': 'success',
                'completed': 'success',
                'active': 'success',
                'pending': 'warning',
                'processing': 'info',
                'failed': 'danger',
                'error': 'danger',
                'inactive': 'secondary'
            };
            return statusMap[status?.toLowerCase()] || 'secondary';
        },

        getStatusText(status) {
            const statusMap = {
                'success': 'Éxito',
                'completed': 'Completado',
                'active': 'Activo',
                'pending': 'Pendiente',
                'processing': 'Procesando',
                'failed': 'Fallido',
                'fail': 'Fallido',
                'error': 'Error',
                'inactive': 'Inactivo'
            };
            return statusMap[status?.toLowerCase()] || status;
        },

        formatDate(dateString) {
            if (!dateString) return '-';
            try {
                return new Date(dateString).toLocaleString('es-ES', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                });
            } catch (error) {
                return dateString;
            }
        },

        showJsonModal(content, title) {
            this.jsonModalTitle = title;
            this.jsonModalContent = content;
            this.$bvModal.show('json-viewer-modal');
        },

        formatJson(content) {
            if (!content) return '';
            if (typeof content === 'string') {
                try {
                    return JSON.stringify(JSON.parse(content), null, 2);
                } catch (e) {
                    return content;
                }
            }
            return JSON.stringify(content, null, 2);
        }
    }
}
</script>

<style scoped>
.subscription-logs {
    min-height: 400px;
}

.logs-table {
    font-size: 0.875rem;
}

.json-viewer {
    background-color: #f8f9fa;
    border-radius: 0.375rem;
    padding: 1rem;
    margin: 0;
    max-height: 400px;
    overflow-y: auto;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    font-size: 0.875rem;
    line-height: 1.4;
}

.logs-table >>> .table th {
    border-top: none;
    font-weight: 600;
    background-color: #f8f9fa;
    font-size: 0.8rem;
    padding: 0.75rem 0.5rem;
}

.logs-table >>> .table td {
    padding: 0.75rem 0.5rem;
    vertical-align: middle;
}

.logs-table >>> .table-hover tbody tr:hover {
    background-color: rgba(0, 123, 255, 0.075);
}
</style>